import { render } from "./loaderModal.vue?vue&type=template&id=5745faa8&scoped=true"
import script from "./loaderModal.vue?vue&type=script&lang=js"
export * from "./loaderModal.vue?vue&type=script&lang=js"

import "./loaderModal.vue?vue&type=style&index=0&id=5745faa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5745faa8"]])

export default __exports__